module.exports = __webpack_public_path__ + "img/用水计划调整流程-2.a8a394c2.png";